import { detectLocale, getBrandName as getBrand } from '@quintoandar/js-intl';
export const getBrandName = () => {
  const locale = detectLocale();

  return getBrand(locale);
};
